module.exports = __webpack_public_path__ + "static/media/box-on-hold.d6bfb70c.svg";